import { eachDayOfInterval, format, isSameDay, isWeekend, parseISO } from 'date-fns';

import { CompanySettings, PeriodRange } from 'api';

export const makeCalendar = (
  periodRange: PeriodRange | null,
  companySettings: CompanySettings | undefined,
) => {
  if (!periodRange) return [];
  const { exceptionHolidays = [], exceptionWorkdays = [] } = companySettings ?? {};

  const holidayDates = exceptionHolidays.map((hd) => parseISO(hd));
  const transferWorkDates = exceptionWorkdays.map((hd) => parseISO(hd));

  const dates = eachDayOfInterval({
    start: new Date(periodRange.startPeriod),
    end: new Date(periodRange.endPeriod),
  });

  return dates.map((d) => ({
    fullDate: d,
    date: format(d, 'yyyy-MM-dd'),
    monthNumber: format(d, 'dd'),
    weekDay: format(d, 'iii').toUpperCase(),
    isToday: isSameDay(d, new Date()),
    isWeekend: isWeekend(d) && !transferWorkDates.some((twd) => isSameDay(d, twd)),
    isHoliday: holidayDates.some((hd) => isSameDay(d, hd)),
  }));
};
